"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _helper = require("@/mixins/helper/helper");

var _permission = require("@/mixins/permission/permission");

var _sidebar = require("./sidebar.constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SidebarComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(SidebarComponent, _Mixins);

  var _super = _createSuper(SidebarComponent);

  function SidebarComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, SidebarComponent);
    _this = _super.apply(this, arguments);
    _this.isDisplaySidebar = false;
    _this.companyName = process.env.VUE_APP_NAME;
    _this.routes = [];
    /*showReport(parentName: string = null, name: string = null): boolean {
      if (parentName === 'report') {
        // if (name) {
        //   if (this.lastMile && name.indexOf('lmd') >= 0) {
        //     return true;
        //   }
               //   if (this.milkRun && name.indexOf('mr') >= 0) {
        //     return true;
        //   }
        // }
               return true;
      } else {
        return true;
      }
    }*/

    return _this;
  } // lastMile: boolean = false;
  // milkRun: boolean = false;


  (0, _createClass2.default)(SidebarComponent, [{
    key: "onPathChanges",
    value: function onPathChanges() {
      this.$emit('onUpdateSidebar', false);
    }
  }, {
    key: "onShowSidebarChanges",
    value: function onShowSidebarChanges(newVal) {
      this.isDisplaySidebar = newVal;
    }
  }, {
    key: "routeList",
    get: function get() {
      if (this.$isLogIn) {
        this.routes = this.$isAdmin ? _sidebar.DEFAULT_ADMIN_ROUTES : _sidebar.DEFAULT_ROUTES;
      }

      return this.routes;
    }
  }, {
    key: "created",
    value: function created() {
      this.isDisplaySidebar = this.isShowSidebar;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      /*if (this.helper.isInArray('lastMileDelivery', this.$userData.permission)) {
        this.lastMile = true;
      }
           if (this.helper.isInArray('milkRun', this.$userData.permission)) {
        this.milkRun = true;
      }*/
    }
  }, {
    key: "showChildren",
    value: function showChildren() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var route = this.routes.find(function (rData) {
        return rData['name'] === name;
      });
      route['hideChildren'] = !route['hideChildren'];
    }
  }]);
  return SidebarComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _permission.PermissionMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isTab', {
  namespace: 'common'
})], SidebarComponent.prototype, "$isTab", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isLogIn', {
  namespace: 'authentication'
})], SidebarComponent.prototype, "$isLogIn", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], SidebarComponent.prototype, "isShowSidebar", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$route.path')], SidebarComponent.prototype, "onPathChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isShowSidebar', {
  immediate: true
})], SidebarComponent.prototype, "onShowSidebarChanges", null);
SidebarComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'SidebarComponent',
  components: {}
})], SidebarComponent);
var _default = SidebarComponent;
exports.default = _default;